import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TShirtSizeDropdownComponent } from './t-shirt-size-dropdown.component';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { DxValidatorComponent } from 'devextreme-angular';

@NgModule({
  declarations: [TShirtSizeDropdownComponent],
  imports: [ CommonModule, SharedModule, DxValidatorComponent ],
  exports: [TShirtSizeDropdownComponent],
})
export class TShirtSizeDropdownModule {}
